(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
const textElement = document.getElementById("text");
const textMessages = [
    "<img src='https://cdn.shopify.com/s/files/1/0819/9988/8658/files/five-starts.svg?v=1697064649' alt='5 stars'><h3 class='ts-subtitle'>GOOD STUFF</h3><p class='ts-description'>This product has been great for me. I will always keep buying Limpomezin, it has saved me from my cholesterol and all the side effects without changing my diet!</p><div class='ts-name'>BIC G. (VERIFIED AMAZON PURCHASE)</div>",
    "<img src='https://cdn.shopify.com/s/files/1/0819/9988/8658/files/five-starts.svg?v=1697064649' alt='5 stars'><h3 class='ts-subtitle'>LIPOMEZIN WORKS!</h3><p class='ts-description'>A relative of ours was trying to replace statin for a long time and with this supplement lipozemin he was able to keep the same level of cholesterol as with statin.</p><div class='ts-name'>VALENTIN G.</div>",
    "<img src='https://cdn.shopify.com/s/files/1/0819/9988/8658/files/five-starts.svg?v=1697064649' alt='5 stars'><h3 class='ts-subtitle'>GOOD RESULTS</h3><p class='ts-description'>A relative of ours was trying to replace statin for a long time and with this supplement lipozemin he was able to keep the same level of cholesterol as with statin.<div class='ts-name'>STEVE N. (VERIFIED AMAZON PURCHASE)</div></p>",
];
let currentIndex = 0;

document.getElementById("previous-button").addEventListener("click", previousSlide);
document.getElementById("next-button").addEventListener("click", nextSlide);

function previousSlide() {
    currentIndex = (currentIndex - 1 + textMessages.length) % textMessages.length;
    textElement.style.opacity = 0;
    setTimeout(() => {
        textElement.innerHTML = textMessages[currentIndex];
        textElement.style.opacity = 1;
    }, 500); // The transition duration is 0.5s, so wait for that duration before changing the content.
}

function nextSlide() {
    currentIndex = (currentIndex + 1) % textMessages.length;
    textElement.style.opacity = 0;
    setTimeout(() => {
        textElement.innerHTML = textMessages[currentIndex];
        textElement.style.opacity = 1;
    }, 500); // The transition duration is 0.5s, so wait for that duration before changing the content.
}

// Function to rotate the message every 5 seconds
function rotateMessages() {
    currentIndex = (currentIndex + 1) % textMessages.length;
    textElement.style.opacity = 0;
    setTimeout(() => {
        textElement.innerHTML = textMessages[currentIndex];
        textElement.style.opacity = 1;
    }, 500); // The transition duration is 0.5s, so wait for that duration before changing the content.
}

// Rotate messages every 5 seconds
const rotationInterval = 15000; // 15 seconds
setInterval(rotateMessages, rotationInterval);

  } catch(e) { console.error(e); }
})();
})();
